export const getOutlets = async () => {
    const response = await fetch("https://sheets.googleapis.com/v4/spreadsheets/1JmQlgtLaSXpdZ0lhoszsu-QHFgi6jJYjS5Fl5LKH6IQ/values/OUTLETS_map_const?key=AIzaSyAoCY0kF37fN2CFBK3YilNFoYKTs3GV16Y");
    const { values } = await response.json();

    const outlets = [];

    values.forEach((row, index) => {
        if (index > 0) {
            const outlet = {};
            row.forEach((item, i) => {
                outlet[values[0][i]] = item;
            })

            if (outlet.LOCATION)
                outlet.LOCATION = outlet.LOCATION.split(",").map(s => parseFloat(s.trim()));

            if (outlet.OWNER_LOCATION)
                outlet.OWNER_LOCATION = outlet.OWNER_LOCATION.split(",").map(s => parseFloat(s.trim()));

            outlet.INDEPENDENCE = outlet.INDEPENDENCE === "TRUE";

            outlet.ID = outlet.TITLE_ID;
            outlet.COVERAGE_CONSTITUENCY = outlet.COVERAGE_PCON || outlet.COVERAGE_PCON_2024 || outlet.COVERAGE_CONSTITUENCY || outlet.PCON24CD;

            if (outlet.COVERAGE_CONSTITUENCY) {
                outlet.COVERAGE_CONSTITUENCY = outlet.COVERAGE_CONSTITUENCY.split(/[;,]/).map(s => s.trim()).filter(s => s !== "");
            }

            if (outlet.ID !== (values[index - 1] ? values[index - 1][0] : null) && outlet.LOCATION)
                outlets.push(outlet);
        }
    });

    return outlets;
}

export const getLADOutlets = async () => {
    const response = await fetch("https://sheets.googleapis.com/v4/spreadsheets/1JmQlgtLaSXpdZ0lhoszsu-QHFgi6jJYjS5Fl5LKH6IQ/values/OUTLETS_map?key=AIzaSyAoCY0kF37fN2CFBK3YilNFoYKTs3GV16Y");
    const { values } = await response.json();

    const outlets = [];

    values.forEach((row, index) => {
        if (index > 0) {
            const outlet = {};
            row.forEach((item, i) => {
                outlet[values[0][i]] = item;
            })

            if (outlet.LOCATION)
                outlet.LOCATION = outlet.LOCATION.split(",").map(s => parseFloat(s.trim()));

            // Handle various independence column names/formats
            outlet.INDEPENDENCE = (
                outlet.INDEPENDENCE === "TRUE" ||
                outlet.INDEPENDENCE === "Yes" ||
                outlet.INDEPENDENT === "Yes" ||
                outlet.INDEPENDENT === "TRUE"
            );

            outlet.ID = outlet.TITLE_ID || outlet.ID;

            // Use LAD coverage - check multiple potential column names
            outlet.COVERAGE_LAD = outlet.COVERAGE_LAD || outlet.COVERAGE_LAD_2023 || outlet.COVERAGE_LAD_2022 || outlet.LAD24CD || outlet.COVERAGE_LAD_2024;

            if (outlet.COVERAGE_LAD) {
                outlet.COVERAGE_LAD = String(outlet.COVERAGE_LAD).split(/[;,]/).map(s => s.trim()).filter(s => s !== "");
            }

            if (outlet.ID && (outlet.TITLE || outlet.TITLE_ID) && outlet.LOCATION && !isNaN(outlet.LOCATION[0]))
                outlets.push(outlet);
        }
    });

    return outlets;
}

export const getLADStats = async () => {
    const response = await fetch("https://sheets.googleapis.com/v4/spreadsheets/1JmQlgtLaSXpdZ0lhoszsu-QHFgi6jJYjS5Fl5LKH6IQ/values/ANALYSIS_LAD!A1:Z500?key=AIzaSyAoCY0kF37fN2CFBK3YilNFoYKTs3GV16Y");
    const { values } = await response.json();

    const stats = [];
    const headers = values[0];

    values.forEach((row, index) => {
        if (index > 0) {
            const stat = {};
            row.forEach((item, i) => {
                stat[headers[i]] = item;
            });

            if (stat.PERIOD === "September 2025" && stat.COVERAGE_LAD_2023) {
                stats.push({
                    id: stat.COVERAGE_LAD_2023,
                    nm: stat.LAD23NM,
                    pop: parseInt(stat.LAD_2021_pop) || 0,
                    classification: stat.CLASSIFICATION,
                    classification2: stat.CLASSIFICATION_2
                });
            }
        }
    });

    return stats;
}